export default "__VITE_ASSET__BCP_ATaR__"